import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import ProductList from '@/components/productList'
import ProductDetails from '@/components/productDetails'
import OfferList from '@/components/offerList'
import OfferDetails from '@/components/offerDetails'

import NewsList from '@/components/newsList'
import NewsDetails from '@/components/newsDetails'

import NoticeList from '@/components/noticeList' 
import NoticeDetails from '@/components/noticeDetails'

import DynamicsList from '@/components/dynamicsList' 
import UpanddownList from '@/components/upanddownList' 

import UserAgreement from '@/components/userAgreement'
// 手机端
import mIndex from '@/components/mobile/mIndex'
import mOfferList from '@/components/mobile/mOfferList'
import mOfferDetails from '@/components/mobile/mOfferDetails'
import mNewsList from '@/components/mobile/mNewsList'
import mNewsDetails from '@/components/mobile/mNewsDetails'

import mClassList from '@/components/mobile/mClassList'
import mDynamicsList from '@/components/mobile/mDynamicsList'
import mProductList from '@/components/mobile/mProductList'
import mProductDetails from '@/components/mobile/mProductDetails'
Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
 Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
 }
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index
    },
    {
      path: '/ProductList', //产品列表
      name: 'ProductList',
      component: ProductList
    },
    {
      path: '/ProductDetails',//产品详情
      name: 'ProductDetails',
      component: ProductDetails
    },
    {
      path: '/DynamicsList',//药材交易动态---市场
      name: 'DynamicsList',
      component: DynamicsList
    },
    {
      path: '/UpanddownList',//药材交易动态---涨幅
      name: 'UpanddownList',
      component: UpanddownList
    },
    
    {
      path: '/OfferList',//报价列表
      name: 'OfferList',
      component: OfferList
    },
    {
      path: '/OfferDetails',//报价详情
      name: 'OfferDetails',
      component: OfferDetails
    },
    {
      path: '/NewsList',//新闻列表
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/NewsDetails',//新闻详情
      name: 'NewsDetails',
      component: NewsDetails
    },
    {
      path: '/NoticeList',//公告列表
      name: 'NoticeList',
      component: NoticeList
    },
    {
      path: '/NoticeDetails',//公告详情
      name: 'NoticeDetails',
      component: NoticeDetails
    },
    {
      path: '/UserAgreement',//用户协议
      name: 'UserAgreement',
      component: UserAgreement
    },
    {
      path: '/mIndex',// 手机端首页
      name: 'mIndex',
      component: mIndex
    },
    {
      path: '/mOfferList',// 手机端 推荐资源
      name: 'mOfferList',
      component: mOfferList
    },
    {
      path: '/mOfferDetails',// 手机端 报价
      name: 'mOfferDetails',
      component: mOfferDetails
    },
    {
      path: '/mNewsList',// 手机端 资讯
      name: 'mNewsList',
      component: mNewsList
    },
    {
      path: '/mNewsDetails',// 手机端 资讯详情
      name: 'mNewsDetails',
      component: mNewsDetails
    },
    {
      path: '/mClassList',// 手机端 产品分类
      name: 'mClassList',
      component: mClassList
    },
    {
      path: '/mDynamicsList',// 手机端 交易动态
      name: 'mDynamicsList',
      component: mDynamicsList
    },
    {
      path: '/mProductList',// 手机端 自营产品
      name: 'mProductList',
      component: mProductList
    },
    {
      path: '/mProductDetails',// 手机端 产品详情
      name: 'mProductDetails',
      component: mProductDetails
    },
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js